/**
 * RPR-6678: Video viewer controller.
 *
 * Backs the #/video/:id route. Fetches lightweight metadata from
 * /api/document/<id>.json (filename, media_type, and the Mux processing
 * fields) then hands the heavy lifting to the <rpr-video-player> directive
 * in the view template, which talks to videoPlaybackService for the signed
 * JWT and mounts <mux-player>.
 *
 * RPR-6741: the Mux processing fields (status / playback id / thumbnail)
 * are forwarded to the directive so a still-processing asset shows the
 * "still being processed" placeholder and self-heals via polling, instead
 * of fetching a playback token immediately, 404ing, and rendering the
 * misleading "Video is not available" message (common for large videos
 * that take a while to transcode).
 *
 * Kept thin on purpose -- if you need to extend behavior, prefer
 * doing it inside the directive so the same code path covers preview-
 * tab inline rendering too.
 */
app.controller('videoViewerController',
  ['$scope', '$routeParams', 'apiHelper', 'portalHelper', 'HttpAuth',
    function ($scope, $routeParams, apiHelper, portalHelper, HttpAuth) {
      $scope.documentId = $routeParams.id;
      $scope.documentName = '';
      $scope.muxProcessingStatus = '';
      $scope.muxPlaybackId = '';
      $scope.muxThumbnailUrl = '';
      $scope.metadataReady = false;
      $scope.notFound = false;
      $scope.loadError = false;

      portalHelper.portalReady(function () {
        const url = apiHelper.getApiUrl() + '/api/document/' + encodeURIComponent($routeParams.id) + '.json';
        HttpAuth.get(url).then(
          function (result) {
            const data = result?.data || {};
            if (data.media_type !== 'video') {
              // Wrong type for this route. Hand off to the same redirect
              // path the picker uses for non-video docs.
              globalThis.location.href = apiHelper.getApiUrl()
                + '/static/pdfjs/index.html?title=' + encodeURIComponent(data.filename || '')
                + '&file=' + encodeURIComponent(data.file || '');
              return;
            }
            $scope.documentName = data.filename || '';
            // RPR-6741: set these BEFORE metadataReady so the ng-if-gated
            // <rpr-video-player> sees populated one-way (@) bindings at link
            // time (the player reads mux-processing-status synchronously).
            $scope.muxProcessingStatus = data.mux_processing_status || '';
            $scope.muxPlaybackId = data.mux_playback_id || '';
            $scope.muxThumbnailUrl = data.mux_thumbnail_url || '';
            $scope.metadataReady = true;
          },
          function (err) {
            const status = err?.status;
            if (status === 404 || status === 403) {
              // Genuinely missing, or not permitted for this user.
              $scope.notFound = true;
            } else {
              // RPR-6741: 5xx / network / unexpected -- don't mislabel an
              // outage as "not found / no access". Show a distinct retry
              // message and leave a console trace for diagnosis (mirrors the
              // 404-vs-503-vs-other branching the directive already does).
              $scope.loadError = true;
              // eslint-disable-next-line no-console
              console.warn('videoViewer: metadata fetch failed', status, err);
            }
          }
        );
      });
    }
  ]
);
